export default __webpack_public_path__ + "static/media/011-Two way.d51a58d8.png";